import { ConfirmDialog } from '@examflow/ui';

interface QuizModalsProps {
  mode?: 'practice' | 'exam';
  showExitConfirm: boolean;
  onCancelExit: () => void;
  onConfirmExit: () => void;

  showSubmitConfirm: boolean;
  onCancelSubmit: () => void;
  onConfirmSubmit: () => void;
  totalQuestions: number;
  answeredCount: number;

  showRestartConfirm: boolean;
  onCancelRestart: () => void;
  onConfirmRestart: () => void;
}

export function QuizModals({
  mode = 'exam',
  showExitConfirm,
  onCancelExit,
  onConfirmExit,
  showSubmitConfirm,
  onCancelSubmit,
  onConfirmSubmit,
  totalQuestions,
  answeredCount,
  showRestartConfirm,
  onCancelRestart,
  onConfirmRestart,
}: QuizModalsProps) {
  const isPractice = mode === 'practice';

  return (
    <>
      <ConfirmDialog
        isOpen={showExitConfirm}
        title={isPractice ? '结束本轮训练？' : '确认退出训练'}
        message={
          isPractice
            ? answeredCount > 0
              ? `已答 ${answeredCount} 题会写入能力诊断；未答不算失败。确定结束吗？`
              : '还没有作答。离开后不会写入训练记录。'
            : '退出后本次训练将结束，已答题目的答案将被保存。确定要退出吗？'
        }
        confirmLabel={isPractice ? (answeredCount > 0 ? '结束并保存' : '离开') : '确认退出'}
        cancelLabel="取消"
        variant="danger"
        onConfirm={onConfirmExit}
        onCancel={onCancelExit}
      />

      <ConfirmDialog
        isOpen={showSubmitConfirm}
        title={isPractice ? '结束本轮？' : '确定交卷吗？'}
        message={
          isPractice
            ? answeredCount > 0
              ? `共准备 ${totalQuestions} 题，已答 ${answeredCount} 题。未答不算失败，已答会写入能力诊断。`
              : `还没有作答。可以继续答题，或直接离开。`
            : `共 ${totalQuestions} 题，已答 ${answeredCount} 题，未答 ${totalQuestions - answeredCount} 题。交卷后将显示成绩与解析。`
        }
        confirmLabel={isPractice ? (answeredCount > 0 ? '结束并保存' : '仍要结束') : '确定交卷'}
        cancelLabel={isPractice ? '继续练' : '继续答题'}
        onConfirm={onConfirmSubmit}
        onCancel={onCancelSubmit}
      />

      <ConfirmDialog
        isOpen={showRestartConfirm}
        title="确定要重新开始吗？"
        message="当前答题进度将清空，将重新生成练习内容。"
        confirmLabel="确定重新开始"
        cancelLabel="取消"
        variant="danger"
        onConfirm={onConfirmRestart}
        onCancel={onCancelRestart}
      />
    </>
  );
}
